export default __webpack_public_path__ + "static/media/roupas.e1172d1d.png";